import { SeoProvider } from '@/components/common/seo-provider';
import type { GatsbySSR } from 'gatsby';

export const wrapRootElement: GatsbySSR['wrapRootElement'] = ({ element }) => (
  <SeoProvider>{element}</SeoProvider>
);
